export default "__VITE_PUBLIC_ASSET__dc28f6b7__"